// Instanz-Maske fuer die gefuehrte Anlage im CI/CD-Import (CicdSetup Sektion 4).
// Bewusst dieselben iio-Bausteine und Feldschnitte wie die Instanz-Maske in
// SpaceDetail (Verbindung-Tab inkl. Service-Key-Paste), aber auf den Import-Fall
// zugeschnitten: Verbindungsfelder kommen vorbefuellt aus dem GitHub-Environment,
// nur die Secrets fehlen (write-only bei GitHub) und sind hier Pflicht.
// SpaceDetail bleibt unangetastet - Konvergenz beider Masken ist als Folgeaufgabe
// in der Projekt-Memory notiert.
//
// Die Texte teilt sich die Maske mit SpaceDetail: derselbe Namensraum "space",
// damit ein Feldname nicht an zwei Stellen unterschiedlich uebersetzt wird.
import { useTranslation } from "react-i18next";

export default function CicdImportInstanceForm({ form, setField, env, addToast }) {
  const { t } = useTranslation(["space", "gemeinsam"]);
  const pre = (key) => (form._prefilled && form._prefilled[key] ? " cs-prefill" : "");
  const hint = (key) => form._prefilled && form._prefilled[key] && <div className="iio-field-hint cs-prefill-hint">{t("import.uebernommen", { env: env.env })}</div>;

  return (
    <div className="cs-instform">
      <div className="iio-field">
        <span className="iio-field-label">{t("import.serviceKey")}</span>
        <textarea
          className="iio-textarea cs-paste"
          placeholder={t("import.serviceKeyPlatzhalter")}
          onPaste={(e) => {
            const text = e.clipboardData.getData("text");
            try {
              const parsed = JSON.parse(text);
              const o = parsed.oauth || parsed;
              if (o.url) setField("tenantUrl", String(o.url).replace(/\/+$/, ""));
              if (o.clientid || o.clientId) setField("clientId", o.clientid || o.clientId);
              if (o.clientsecret || o.clientSecret) setField("clientSecret", o.clientsecret || o.clientSecret);
              if (o.tokenurl || o.tokenUrl) setField("tokenUrl", o.tokenurl || o.tokenUrl);
              setField("authType", "oauth");
              addToast(t("meldung.serviceKeyImportiert"), "success");
              e.preventDefault();
            } catch {
              addToast(t("meldung.serviceKeyUngueltig"), "error");
            }
          }}
        />
      </div>

      <div className="iio-field">
        <label className="iio-field-label" htmlFor="cs-inst-name">{t("verbindung.name")}</label>
        <input id="cs-inst-name" className={"iio-input" + pre("name")} value={form.name} onChange={(e) => setField("name", e.target.value)} placeholder={t("import.namePlatzhalter")}/>
      </div>

      <div className="iio-field">
        <label className="iio-field-label" htmlFor="cs-inst-desc">{t("verbindung.beschreibung")}</label>
        <textarea id="cs-inst-desc" className="iio-textarea" value={form.description} onChange={(e) => setField("description", e.target.value)} placeholder={t("verbindung.beschreibungPlatzhalter")}/>
        <div className="iio-field-hint">{t("verbindung.beschreibungHinweis")}</div>
      </div>

      <div className="iio-field">
        <span className="iio-field-label">{t("verbindung.auth")}</span>
        <div className="iio-auth-toggle">
          <button type="button" className={form.authType === "oauth" ? "is-active" : ""} onClick={() => setField("authType", "oauth")}>{t("verbindung.authOauth")}</button>
          <button type="button" className={form.authType === "basic" ? "is-active" : ""} onClick={() => setField("authType", "basic")}>{t("verbindung.authBasic")}</button>
        </div>
        {hint("authType")}
      </div>

      <div className="iio-field">
        <label className="iio-field-label">{t("verbindung.tenantUrl")}</label>
        <input className={"iio-input iio-input--mono" + pre("tenantUrl")} value={form.tenantUrl} onChange={(e) => setField("tenantUrl", e.target.value)} placeholder={t("verbindung.tenantUrlPlatzhalter")}/>
        {hint("tenantUrl")}
      </div>

      {form.authType === "oauth" ? (
        <>
          <div className="iio-field">
            <label className="iio-field-label">{t("verbindung.tokenUrl")}</label>
            <input className={"iio-input iio-input--mono" + pre("tokenUrl")} value={form.tokenUrl} onChange={(e) => setField("tokenUrl", e.target.value)} placeholder={t("verbindung.tokenUrlPlatzhalter")}/>
            {hint("tokenUrl")}
          </div>
          <div className="iio-fields-2">
            <div className="iio-field">
              <label className="iio-field-label">{t("verbindung.clientId")}</label>
              <input className={"iio-input iio-input--mono" + pre("clientId")} value={form.clientId} onChange={(e) => setField("clientId", e.target.value)}/>
              {hint("clientId")}
            </div>
            <div className="iio-field">
              <label className="iio-field-label">{t("verbindung.clientSecret")} <span className="cs-req">{t("import.pflichtfeld")}</span></label>
              <input className="iio-input iio-input--mono" type="password" value={form.clientSecret} onChange={(e) => setField("clientSecret", e.target.value)} placeholder={t("import.secretPlatzhalter")}/>
              <div className="iio-field-hint">{t("import.secretHinweis")}</div>
            </div>
          </div>
        </>
      ) : (
        <div className="iio-fields-2">
          <div className="iio-field">
            <label className="iio-field-label">{t("verbindung.benutzername")}</label>
            <input className={"iio-input iio-input--mono" + pre("username")} value={form.username} onChange={(e) => setField("username", e.target.value)}/>
            {hint("username")}
          </div>
          <div className="iio-field">
            <label className="iio-field-label">{t("verbindung.passwort")} <span className="cs-req">{t("import.pflichtfeld")}</span></label>
            <input className="iio-input iio-input--mono" type="password" value={form.password} onChange={(e) => setField("password", e.target.value)}/>
            <div className="iio-field-hint">{t("import.secretHinweis")}</div>
          </div>
        </div>
      )}

      {form.policyUsername ? (
        <div className="iio-fields-2">
          <div className="iio-field">
            <label className="iio-field-label">{t("import.policyBenutzer")}</label>
            <input className={"iio-input iio-input--mono" + pre("policyUsername")} value={form.policyUsername} onChange={(e) => setField("policyUsername", e.target.value)}/>
            {hint("policyUsername")}
          </div>
          <div className="iio-field">
            <label className="iio-field-label">{t("import.policyPasswort")}</label>
            <input className="iio-input iio-input--mono" type="password" value={form.policyPassword} onChange={(e) => setField("policyPassword", e.target.value)}/>
            <div className="iio-field-hint">{t("import.policyHinweis")}</div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
